// extracted by css-extract-rspack-plugin
export default {"image-block":"InstagramImage-module__image-block--Z4oi_","image":"InstagramImage-module__image--mrklw"};